import { CUSTOMER_FEEDBACK_QUESTIONS, CUSTOMER_FEEDBACK_QUESTIONS_MSB } from '@/graphql/customerFeedback';
import logger from '@/modules/Logger';
import { PLATFORM } from '@/utils/constants';
import _ from 'lodash';

export const CustomerFeedbackQuestionsService = {
  msb: (successCallback, errorCallback) => {
    logger.debug(`[CFE][CustomerFeedbackQuestions] Fetched customer feedback questions from MSB GraphQL endpoint`, {
      operation: 'cfe:get-customer-feedback-questions'
    });

    return {
      client: 'msb',
      query: CUSTOMER_FEEDBACK_QUESTIONS_MSB,
      variables() {
        return {
          platform: PLATFORM.mystage
        };
      },
      error() {
        logger.debug(`[CFE][CustomerFeedbackQuestions] Empty result from customer feedback questions api MSB endpoint`, {
          operation: 'cfe:get-customer-feedback-questions',
        });

        errorCallback();
      },
      result({ data }) {
        successCallback(data ? {
          questions: _.cloneDeep(data.customer_feedback_questions),
          options: data.customer_feedback_options
        } : null);
      }
    };
  },

  mbti: (successCallback, errorCallback) => {
    logger.debug(`[CFE][CustomerFeedbackQuestions] Fetched customer feedback questions from MBTI GraphQL endpoint`, {
      operation: 'cfe:get-customer-feedback-questions'
    });

    return {
      client: 'mbti',
      query: CUSTOMER_FEEDBACK_QUESTIONS,
      variables() {
        return {
          platform: PLATFORM.mystage
        };
      },
      error() {
        logger.debug(`[CFE][CustomerFeedbackQuestions] Empty result from customer feedback questions api MBTI endpoint`, {
          operation: 'cfe:get-customer-feedback-questions',
        });

        errorCallback();
      },
      result({ data }) {
        successCallback(data ? {
          questions: data.customer_feedback_questions,
          options: data.customer_feedback_options
        } : null);
      }
    };
  }
};

// Route legacy endpoint to MBTI, because this API does not have FuelPHP version
CustomerFeedbackQuestionsService.legacy = CustomerFeedbackQuestionsService.mbti;
